/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */
import isDate from 'lodash/isDate';
import isNil from 'lodash/isNil';

import {
	addDays,
	getLastDayOfMonth,
	getFirstDayOfWeek,
	getLastDayOfWeek,
	getTimeSpanInCalendarDays,
	createRangeForDays
} from 'js-date-helper';



/* ========================================================================== *\
	PUBLIC API
\* ========================================================================== */
/**
 *
 * @param {Date} date
 * @param {number} firstWeekDay
 * @param {boolean} padMonth
 *
 * @returns {Array<Date>}
 */
function getCalendarMonthForDate(date, firstWeekDay = 1, padMonth = false) {
	const
		month = new Date(date).setDate(1),
		lastDay = getLastDayOfMonth(month),
		startDate = getFirstDayOfWeek(month, firstWeekDay),
		endDate = getLastDayOfWeek(lastDay);

	return (padMonth && getTimeSpanInCalendarDays(startDate, endDate) !== 41)
		? createRangeForDays(startDate, addDays(endDate, 7))
		: createRangeForDays(startDate, endDate);
}

/**
 *
 * @param {Date | null} date
 *
 * @returns {Date | null}
 */
function getNewNullableDateInstance(date) {
	return isDate(date)
		? new Date(date)
		: null;
}

/**
 *
 * @param {Date | null} date
 * @param {Date | null } otherDate
 *
 * @returns {boolean}
 */
function isNullableDateEqual(date, otherDate) {
	if (
		isDate(date) !== isDate(otherDate)
	) {
		return false;
	}

	if (isNil(date)) {
		return true;
	}

	return date.getTime() === otherDate.getTime();
}



/* ========================================================================== *\
	EXPORTS
\* ========================================================================== */
export {
	getCalendarMonthForDate,
	getNewNullableDateInstance,
	isNullableDateEqual
};
